import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Divider,
  Drawer,
  FormControl,
  Grow,
  MenuItem,
  Paper,
  Select,
  SelectChangeEvent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useTheme,
} from '@mui/material';
import MuiTextField from '@mui/material/TextField';
import { useQuery } from 'react-query';
import { useEffect, useState } from 'react';
import { summaryGet } from 'api/api';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
//import { AgGridReact } from 'ag-grid-react';
//import { ColDef } from 'ag-grid-community';
import React from 'react';
import moment from 'moment';
import { easepick, RangePlugin, AmpPlugin } from '@easepick/bundle';
import easepickCss from '@easepick/bundle/dist/index.css?resource';
import easepickDarkCss from '../easepick.css?resource';
import { CircularProgressWithLabel } from 'components/CircularProgressWithLabel';
import { useMedia } from 'react-use';
import {
  Chart as ChartJS,
  LinearScale,
  BarElement,
  Title,
  ChartOptions,
} from 'chart.js';
import { Doughnut, Bar } from 'react-chartjs-2';
ChartJS.register(LinearScale, Title, BarElement);
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import { venuesGet } from 'api/api';

let picker: easepick.Core | null = null;

const formatNumber = (number: number) => {
  return new Intl.NumberFormat().format(number);
};

function PaperComponent(paperProps, ref) {
  return (
    <Grow in>
      <Paper {...paperProps} ref={ref} />
    </Grow>
  );
}

export const Summary = ({
  selectedOrganization,
}: {
  selectedOrganization: any;
}) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [rightDrawerOpen, setRightDrawerOpen] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertTitle, setAlertTitle] = useState('');
  const [alertMessage, setAlertMessage] = useState('');
  const [selected, setSelected] = useState<any | null>(null);
  const PaperComponentForward = React.forwardRef(PaperComponent);
  const [venue, setVenue] = useState<any>({ name: 'All venues', id: '0' });

  const [dateRange, setDateRange] = useState<{
    start: Date;
    end: Date;
  }>({
    start: moment().add(-8, 'days').startOf('day').toDate(),
    end: moment().add(-1, 'days').endOf('day').toDate(),
  });
  // eslint-disable-next-line sonarjs/no-duplicate-string
  const [dateRangeName, setDateRangeName] = useState('Last 7 days');
  const isDarkTheme = useMedia('(prefers-color-scheme: dark)');
  const mobileFullWidth = 'calc(100vw - 32px)';

  const theme = useTheme();
  const isWide = useMedia('(min-width: 768px)');

  const {
    data: venuesResponse,
    isLoading: venuesIsLoading,
    error: venuesError,
    refetch: refetchVenues,
  } = useQuery(['venuesGet'], venuesGet(selectedOrganization?.id), {
    enabled: !!selectedOrganization,
    refetchOnWindowFocus: false,
  });
  const venues: any = venuesResponse?.data;

  const venueOptions = [
    { name: 'All venues', id: '0' },
    ...(!!venues ? venues : []),
  ];

  const dataStyle = {
    minWidth: { xs: '20%', sm: '80px' },
    minHeight: '3rem',
  };

  const valueStyle = {
    fontSize: '1.6rem',
  };

  const pieColors = [
    theme.palette.primary.main,
    '#ccc',
    '#777',
    '#444',
    '#999',
    '#000',
    '#fff',
  ];

  const pieOptions: ChartOptions<any> = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: '83%',
    color: '#fff',
    fullSize: false,
    layout: {
      autoPadding: false,
    },
    plugins: {
      legend: {
        display: false,
        position: 'right' as const,
        align: 'center',
        labels: {
          textAlign: 'left',
          color: theme.palette.text.secondary,
          boxWidth: 8,
          boxHeight: 8,
          usePointStyle: true,
        },
      },
      title: {
        display: false,
        text: 'Types',
        color: theme.palette.text.secondary,
        font: { weight: '500', size: 15 },
      },
    },
  };

  /*
  const myAnnotations = [event.preShowStartTime, event.featureStartTime].filter(
    Boolean,
  );
*/

  useEffect(() => {
    picker = new easepick.create({
      element: document.getElementById('datepicker')!,
      plugins: [RangePlugin, AmpPlugin],
      css: [easepickCss, easepickDarkCss],
      zIndex: 1,
      //format: 'DD/MM/YYYY',
    });

    picker.setDateRange(dateRange.start, dateRange.end);
    picker.on('select', (e) => {
      const { start, end } = e.detail;

      setDateRange({
        start,
        end,
      });
    });

    return () => {
      picker?.destroy();
    };
  }, []);

  const setDates = (start, end) => {
    setDateRange({
      start,
      end,
    });
    picker?.setDateRange(start, end);
  };

  const handleDateChange = (event: SelectChangeEvent) => {
    setDateRangeName(event.target.value);
    switch (event.target.value) {
      case 'Next 90 days':
        setDates(
          moment().add(1, 'days').endOf('day').toDate(),
          moment().add(91, 'days').startOf('day').toDate(),
        );
        break;
      case 'Next 30 days':
        setDates(
          moment().add(1, 'days').endOf('day').toDate(),
          moment().add(31, 'days').startOf('day').toDate(),
        );
        break;
      case 'Next 7 days':
        setDates(
          moment().add(1, 'days').endOf('day').toDate(),
          moment().add(8, 'days').startOf('day').toDate(),
        );
        break;
      case 'Tomorrow':
        setDates(
          moment().add(1, 'd').startOf('day').toDate(),
          moment().add(1, 'd').endOf('day').toDate(),
        );
        break;
      case 'Today':
        setDates(moment().toDate(), moment().endOf('day').toDate());
        break;
      case 'Yesterday':
        setDates(
          moment().add(-1, 'd').startOf('day').toDate(),
          moment().add(-1, 'd').endOf('day').toDate(),
        );
        break;
      case 'Last 7 days':
        setDates(
          moment().add(-8, 'days').startOf('day').toDate(),
          moment().add(-1, 'days').endOf('day').toDate(),
        );
        break;
      case 'Last 14 days':
        setDates(
          moment().add(-15, 'days').startOf('day').toDate(),
          moment().add(-1, 'days').endOf('day').toDate(),
        );
        break;
      case 'Last 28 days':
        setDates(
          moment().add(-29, 'days').startOf('day').toDate(),
          moment().add(-1, 'days').endOf('day').toDate(),
        );
        break;
      case 'Last 30 days':
        setDates(
          moment().add(-31, 'days').startOf('day').toDate(),
          moment().add(-1, 'days').endOf('day').toDate(),
        );
        break;
      case 'Last 90 days':
        setDates(
          moment().add(-91, 'days').startOf('day').toDate(),
          moment().add(-1, 'days').endOf('day').toDate(),
        );
        break;
      case 'Last 180 days':
        setDates(
          moment().add(-181, 'days').startOf('day').toDate(),
          moment().add(-1, 'days').endOf('day').toDate(),
        );
        break;
      case 'Last calendar year':
        setDates(
          moment().add(-1, 'year').startOf('year').toDate(),
          moment().add(-1, 'year').endOf('year').toDate(),
        );
        break;
    }
  };

  const CustomStatusBar = (props: any) => {
    return (
      <div className="ag-status-bar-center">
        <div className="ag-status-name-value ag-status-panel ag-status-panel-total-row-count">
          <span className="label">Total Rows</span>:&nbsp;
          <span className="ag-status-name-value-value">{props.total}</span>
        </div>
      </div>
    );
  };

  const alert = (title, message) => {
    setAlertTitle(title);
    setAlertMessage(message);
    setAlertOpen(true);
  };

  /*
  const { data: getUserAdminOfOrganizationsResponse } = useQuery(
    'getUserAdminOfOrganizations',
    getUserAdminOfOrganizations,
    {
      enabled: true,
      refetchOnWindowFocus: false,
      suspense: true,
    },
  );

  const userAdminOfOrganizations = getUserAdminOfOrganizationsResponse!.data;

  const [selectedOrganizationId, setSelectedOrganizationId] = useState<number>(
    userAdminOfOrganizations[0]?.id,
  );
  */

  const {
    data: response,
    isLoading,
    error,
    refetch,
  } = useQuery(
    ['summaryGet', selectedOrganization?.id, dateRange, venue],
    summaryGet(selectedOrganization?.id as number, dateRange, venue.id),
    {
      enabled: !!selectedOrganization,
      refetchOnWindowFocus: false,
    },
  );
  const data: any = response?.data;

  const dateFormat = 'MMM D'; // HH:mm

  const eventCountChartData = data
    ? {
        datasets: [
          {
            label: 'Event count',
            data: Object.entries(data.eventCountByDate).map(
              ([date, eventCount]: any) => ({
                x: date,
                y: eventCount,
              }),
            ),
            borderColor: theme.palette.primary.main,
            backgroundColor: theme.palette.primary.main,
          },
        ],
      }
    : {};

  const soldTicketCountChartData: any = data
    ? {
        datasets: [
          {
            label: 'Sold ticket count',
            data: Object.entries(data.ticketCountPaidByDay).map(
              ([date, count]: any) => ({
                x: date,
                y: count,
              }),
            ),
            borderColor: theme.palette.primary.main,
            backgroundColor: theme.palette.primary.main,
          },
        ],
      }
    : {};

  const orderCountChartData = data
    ? {
        datasets: [
          {
            label: 'Order count',
            data: Object.entries(data.orderCountPaidByDay).map(
              ([date, count]: any) => ({
                x: date,
                y: count,
              }),
            ),
            borderColor: theme.palette.primary.main,
            backgroundColor: theme.palette.primary.main,
          },
        ],
      }
    : {};

  const ticketCountChartData = data
    ? {
        datasets: [
          {
            label: 'Used ticket count',
            data: Object.entries(data.ticketCountUsedForDateByDate).map(
              ([date, count]: any) => ({
                x: date,
                y: count,
              }),
            ),
            borderColor: theme.palette.primary.main,
            backgroundColor: theme.palette.primary.main,
          },
          {
            label: 'Unused ticket count',
            data: Object.entries(data.ticketCountUnusedForDateByDate).map(
              ([date, count]: any) => ({
                x: date,
                y: count,
              }),
            ),
            borderColor: '#888',
            backgroundColor: '#888',
          },
        ],
      }
    : {};

  return (
    <>
      <React.Fragment key="right">
        <Drawer
          anchor="right"
          open={rightDrawerOpen}
          onClose={() => {
            refetch();
            setRightDrawerOpen(false);
          }}
        >
          <Box sx={{ width: { xs: '100vw', sm: '600px' } }}>
            <Typography
              variant="h1"
              sx={{ fontSize: '1.3em', fontWeight: 500, m: '16px 24px' }}
            >
              {!!selected ? 'Edit event' : 'Add event'}
            </Typography>
            <Divider />
            <Box sx={{ padding: '24px' }}>
              <Box sx={{ mb: '20px' }}>
                <Typography sx={{ fontWeight: 500, display: 'inline' }}>
                  Organization:{' '}
                </Typography>
                {selectedOrganization?.name}
              </Box>
              {/*
              {!!selected && (
                <Box sx={{ mb: '16px' }}>
                  <Typography sx={{ fontWeight: 500, display: 'inline' }}>
                    User:{' '}
                  </Typography>
                  {selected?.name}
                </Box>
              )}
              */}
            </Box>
          </Box>
        </Drawer>
      </React.Fragment>
      <Dialog
        open={alertOpen}
        onClose={() => setAlertOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`${alertTitle}`}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`${alertMessage}`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAlertOpen(false)}>OK</Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {'Deletion confirmation'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`Are you sure you want to delete this? The event will not be deleted if it has sold tickets.`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
          <Button
            onClick={async () => {
              try {
                setDialogOpen(false);
                if (response) {
                  refetch();
                  setDialogOpen(false);
                  setRightDrawerOpen(false);
                }
              } catch (error: any) {
                refetch();
                setDialogOpen(false);
                setRightDrawerOpen(false);
                alert(error.error, error.message);
              }
            }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: '1',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            flexShrink: 0,
            flexGrow: 0,
            alignItems: 'center',
            gap: '8px 12px',
            minHeight: '56px',
            maxWidth: '100vw',
            flexWrap: 'wrap',
            padding: '12px 0 8px',
            mb: '6px',
          }}
        >
          <Typography
            variant="h4"
            component="h2"
            sx={{
              fontSize: '1.25rem',
              mb: '6px',
              width: { xs: '100%', sm: 'auto' },
            }}
          >
            Summary
          </Typography>
          <Box className="field-with-icon" sx={{ position: 'relative' }}>
            {dateRangeName != 'Custom' && (
              <FormControl
                sx={{
                  width: { xs: '100%', sm: 'auto' },
                }}
              >
                <Select
                  size="small"
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={dateRangeName}
                  onChange={handleDateChange}
                  sx={{
                    width: { xs: mobileFullWidth, sm: '210px' },
                  }}
                >
                  <MenuItem value={'Next 90 days'}>Next 90 days</MenuItem>
                  <MenuItem value={'Next 30 days'}>Next 30 days</MenuItem>
                  <MenuItem value={'Next 7 days'}>Next 7 days</MenuItem>
                  <MenuItem value={'Tomorrow'}>Tomorrow</MenuItem>
                  <MenuItem value={'Today'}>Today</MenuItem>
                  <MenuItem value={'Yesterday'}>Yesterday</MenuItem>
                  <MenuItem value={'Last 7 days'}>Last 7 days</MenuItem>
                  <MenuItem value={'Last 14 days'}>Last 14 days</MenuItem>
                  <MenuItem value={'Last 28 days'}>Last 28 days</MenuItem>
                  <MenuItem value={'Last 30 days'}>Last 30 days</MenuItem>
                  <MenuItem value={'Last 90 days'}>Last 90 days</MenuItem>
                  <MenuItem value={'Last 180 days'}>Last 180 days</MenuItem>
                  <MenuItem value={'Last calendar year'}>
                    Last calendar year
                  </MenuItem>
                  <MenuItem value={'Custom'}>Custom range</MenuItem>
                </Select>
              </FormControl>
            )}
            <CalendarMonthOutlinedIcon
              className="field-icon"
              sx={{ position: 'absolute', top: '7px', left: '10px' }}
            />
            <Box
              sx={{
                display: dateRangeName == 'Custom' ? 'block' : 'none',
                position: 'relative',
              }}
            >
              <MuiTextField
                size="small"
                id="datepicker"
                fullWidth
                sx={{
                  width: { xs: mobileFullWidth, sm: '260px' },
                  display: dateRangeName == 'Custom' ? 'block' : 'none',
                }}
              />
              <ArrowDropDownIcon
                sx={{
                  position: 'absolute',
                  top: '7px',
                  right: '7px',
                  opacity: isDarkTheme ? 1 : 0.645,
                  pointerEvents: 'none',
                }}
              />
            </Box>
          </Box>
          <Box className="field-with-icon" sx={{ position: 'relative' }}>
            <Autocomplete
              PaperComponent={PaperComponentForward}
              disablePortal
              selectOnFocus
              clearOnBlur
              id="venue"
              size="small"
              options={venueOptions}
              getOptionLabel={(option) => option.name}
              defaultValue={venueOptions[0]}
              isOptionEqualToValue={(option: any, value: any) => {
                return option.id === value.id;
              }}
              onChange={(e: any, newValue: any) => {
                setVenue(newValue);
              }}
              sx={{ width: { xs: mobileFullWidth, sm: '300px' } }}
              renderInput={(params) => <TextField {...params} />}
            />
            <PlaceOutlinedIcon
              className="field-icon"
              sx={{ position: 'absolute', top: '8px', left: '10px' }}
            />
          </Box>
        </Box>

        {!data && (
          <Box sx={{ textAlign: 'center', mt: 6 }}>
            <CircularProgress />
          </Box>
        )}

        {data && (
          <>
            <Box
              sx={{
                display: 'grid',
                gridGap: '16px',
                gridTemplateColumns: {
                  xs: 'none',
                  sm: 'repeat(auto-fit,minmax(360px,1fr))',
                },
              }}
            >
              <Card
                sx={{
                  background: theme.palette.primary.main,
                  color: '#ffffff',
                }}
              >
                <CardContent
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    gap: '16px 24px ',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '16px',
                    }}
                  >
                    <Box sx={dataStyle}>
                      <Typography>Total tickets sold</Typography>
                      <Typography sx={valueStyle}>
                        {formatNumber(data.ticketCount)}
                      </Typography>
                    </Box>
                  </Box>
                  <Box sx={dataStyle}>
                    <Typography>Total revenue</Typography>
                    <Box sx={valueStyle}>
                      {data.ordersByCurrency &&
                      Object.keys(data.ordersByCurrency).length != 0
                        ? Object.entries(data.ordersByCurrency).map(
                            ([currencyName, currency]: any, index) => (
                              <Box key={currencyName}>
                                {index > 0 && '<br/>'}
                                {formatNumber(currency._sum)} {currencyName}
                              </Box>
                            ),
                          )
                        : 0}
                    </Box>
                  </Box>
                </CardContent>
              </Card>
              <Card>
                <CardContent>
                  <Box
                    // eslint-disable-next-line sonarjs/no-duplicate-string
                    sx={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <Typography
                      variant="h3"
                      sx={{ fontSize: '1rem', mb: '16px' }}
                    >
                      Tickets
                    </Typography>
                    <Typography
                      variant="h3"
                      sx={{ fontSize: '1rem', mb: '16px' }}
                    >
                      Total inventory:{' '}
                      {formatNumber(data.ticketCountForDateTotalInventory)}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      textAlign: 'center',
                    }}
                  >
                    <CircularProgressWithLabel
                      label="Sold"
                      realvalue={formatNumber(data.ticketCountForDate)}
                      value={
                        !!data.ticketCountForDate
                          ? (data.ticketCountForDate * 100) /
                            data.ticketCountForDateTotalInventory
                          : 0
                      }
                    />
                  </Box>
                </CardContent>
              </Card>
              <Card>
                <CardContent>
                  <Typography
                    variant="h3"
                    sx={{ fontSize: '1rem', mb: '16px' }}
                  >
                    Sold tickets
                  </Typography>

                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      gap: { xs: '6px', sm: '16px' },
                      justifyContent: 'space-evenly',
                    }}
                  >
                    <CircularProgressWithLabel
                      label="Used"
                      realvalue={formatNumber(data.ticketCountForDateUsed)}
                      value={
                        !!data.ticketCountForDateUsed
                          ? 100 -
                            (data.ticketCountForDateUnused * 100) /
                              data.ticketCountForDate
                          : 0
                      }
                    />
                    <CircularProgressWithLabel
                      label="Unused"
                      realvalue={formatNumber(data.ticketCountForDateUnused)}
                      value={
                        !!data.ticketCountForDateUnused
                          ? (data.ticketCountForDateUnused * 100) /
                            data.ticketCountForDate
                          : 0
                      }
                    />
                  </Box>
                </CardContent>
              </Card>
              {data.ticketCountForDateByType &&
                Object.keys(data.ticketCountForDateByType).length != 0 && (
                  <Card>
                    <CardContent>
                      <Typography
                        variant="h3"
                        sx={{ fontSize: '1rem', mb: '16px' }}
                      >
                        Tickets per type
                      </Typography>
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          gap: '16px',
                        }}
                      >
                        <Box
                          className="circularChartContainer"
                          sx={{
                            width: isWide ? '144px' : '120px',
                            height: isWide ? '144px' : '120px',
                            position: 'relative',
                          }}
                        >
                          <Typography
                            sx={{
                              width: '100%',
                              height: '100%',
                              position: 'absolute',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              top: 0,
                              color: theme.palette.text.secondary,
                              pointerEvents: 'none',
                              zIndex: -1,
                            }}
                          >
                            Types
                          </Typography>
                          <Box
                            sx={{
                              zIndex: 100,
                              width: '100%',
                              height: '100%',
                            }}
                          >
                            <Doughnut
                              options={pieOptions as any}
                              data={{
                                labels: Object.values(
                                  data.ticketCountForDateByType,
                                ).map((ticketType: any) => ticketType.name),

                                datasets: [
                                  {
                                    label: 'Ticket types',
                                    data: Object.values(
                                      data.ticketCountForDateByType,
                                    ).map(
                                      (ticketType: any) => ticketType._count,
                                    ),

                                    backgroundColor: [
                                      theme.palette.primary.main,
                                      '#ccc',
                                      '#777',
                                      '#444',
                                      '#999',
                                      '#000',
                                      '#fff',
                                    ],
                                    borderWidth: 0,
                                  },
                                ],
                              }}
                            />
                          </Box>
                        </Box>
                        <Box>
                          <Box>
                            {!!data.ticketCountForDateByType &&
                              Object.entries(data.ticketCountForDateByType).map(
                                ([id, ticketType]: any, index) => (
                                  <Box key={id}>
                                    <Box
                                      sx={{
                                        background: pieColors[index],
                                        width: '0.75rem',
                                        height: '0.75rem',
                                        display: 'inline-block',
                                        borderRadius: '100px',
                                        mr: '6px',
                                      }}
                                    ></Box>
                                    <Typography
                                      color="text.secondary"
                                      sx={{ display: 'inline' }}
                                    >
                                      {ticketType.name}:{' '}
                                      {Math.round(
                                        (ticketType._count * 100) /
                                          data.ticketCountForDate,
                                      )}
                                      % {formatNumber(ticketType._count)}
                                    </Typography>
                                  </Box>
                                ),
                              )}
                          </Box>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                )}
              {/*}
              {!!orderCountChartData.datasets &&
                !orderCountChartData.datasets[0].data.length && (
                  <Typography>No payments</Typography>
                )}
                {*/}
              {!!orderCountChartData.datasets &&
                !!orderCountChartData.datasets[0].data.length && (
                  <Card>
                    <CardContent>
                      <Typography
                        variant="h3"
                        sx={{ fontSize: '1rem', mb: '16px' }}
                      >
                        Orders per payment method
                      </Typography>
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          gap: '16px',
                        }}
                      >
                        <Box
                          sx={{
                            width: isWide ? '144px' : '120px',
                            height: isWide ? '144px' : '120px',
                            position: 'relative',
                          }}
                        >
                          <Typography
                            sx={{
                              width: '100%',
                              height: '100%',
                              position: 'absolute',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              top: 0,
                              color: theme.palette.text.secondary,
                              pointerEvents: 'none',
                              zIndex: -1,
                            }}
                          >
                            Methods
                          </Typography>
                          <Box
                            sx={{
                              zIndex: 100,
                              width: '100%',
                              height: '100%',
                            }}
                          >
                            <Doughnut
                              options={pieOptions as any}
                              data={{
                                labels: Object.entries(
                                  data.ordersByPaymentMethod,
                                ).map(
                                  ([methodName, method]: any) => methodName,
                                ),

                                datasets: [
                                  {
                                    label: 'Ticket types',
                                    data: Object.entries(
                                      data.ordersByPaymentMethod,
                                    ).map(
                                      ([methodName, method]: any) =>
                                        method._count,
                                    ),

                                    backgroundColor: [
                                      theme.palette.primary.main,
                                      '#ccc',
                                      '#777',
                                      '#444',
                                      '#999',
                                      '#000',
                                      '#fff',
                                    ],
                                    borderWidth: 0,
                                  },
                                ],
                              }}
                            />
                          </Box>
                        </Box>
                        <Box>
                          <Box>
                            {!!data.ordersByPaymentMethod &&
                              Object.entries(data.ordersByPaymentMethod).map(
                                ([methodName, method]: any, index) => (
                                  <Box key={methodName}>
                                    <Box
                                      sx={{
                                        background: pieColors[index],
                                        width: '0.75rem',
                                        height: '0.75rem',
                                        display: 'inline-block',
                                        borderRadius: '100px',
                                        mr: '6px',
                                      }}
                                    ></Box>
                                    <Typography
                                      color="text.secondary"
                                      sx={{
                                        display: 'inline',
                                      }}
                                    >
                                      {methodName}:{' '}
                                      {formatNumber(method._count)}
                                    </Typography>
                                  </Box>
                                ),
                              )}
                          </Box>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                )}
              {!!data.ticketCountPerEventTypeSorted &&
                data.ticketCountPerEventTypeSorted.length != 0 && (
                  <TableContainer component={Paper} sx={{ width: '100%' }}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>
                            <Typography variant="h3" sx={{ fontSize: '1rem' }}>
                              Top 5 best performing
                            </Typography>
                          </TableCell>
                          <TableCell align="right">
                            <Typography variant="h3" sx={{ fontSize: '1rem' }}>
                              Tickets sold
                            </Typography>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {data.ticketCountPerEventTypeSorted
                          .slice(0, 5)
                          .map((row) => (
                            <TableRow
                              key={row.id}
                              sx={{
                                '&:last-child td, &:last-child th': {
                                  border: 0,
                                },
                              }}
                            >
                              <TableCell component="th" scope="row">
                                {row.name}
                              </TableCell>
                              <TableCell align="right">
                                {formatNumber(row._count)}
                              </TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              {/*}
              {!!ticketCountChartData.datasets &&
                !(
                  ticketCountChartData.datasets[0].data.length ||
                  ticketCountChartData.datasets[1].data.length
                ) && <Typography>No tickets</Typography>}
                {*/}
              {!!ticketCountChartData.datasets &&
                !!(
                  ticketCountChartData.datasets[0].data.length ||
                  ticketCountChartData.datasets[1].data.length
                ) && (
                  <Card
                    sx={{
                      gridColumn: { xs: 'span 1', md: 'span 2' },
                    }}
                  >
                    <CardContent>
                      <Box
                        sx={{ flexBasis: { xs: '100%', sm: 0 }, flexGrow: 1 }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                          }}
                        >
                          <Typography
                            variant="h3"
                            sx={{ fontSize: '1rem', mb: '16px' }}
                          >
                            Tickets sold for the given date
                          </Typography>
                          <Typography
                            variant="h3"
                            sx={{ fontSize: '1rem', mb: '16px' }}
                          >
                            Total: {formatNumber(data.ticketCountForDate)}
                          </Typography>
                        </Box>
                        <Box sx={{ height: isWide ? '270px' : '160px' }}>
                          <Bar
                            options={{
                              responsive: true,
                              maintainAspectRatio: false,
                              plugins: {
                                legend: {
                                  display: false,
                                  position: 'right' as const,
                                },
                                title: {
                                  display: false,
                                  text: 'Tickets',
                                  color: theme.palette.text.secondary,
                                  font: { weight: '500', size: 15 },
                                },
                              },

                              scales: {
                                y: {
                                  stacked: true,
                                  ticks: {
                                    autoSkip: true,
                                    color: theme.palette.text.secondary,
                                  },
                                  grid: {
                                    // eslint-disable-next-line sonarjs/no-duplicate-string
                                    color: 'rgba(127 127 127/0.2)',
                                  },
                                },
                                x: {
                                  stacked: true,
                                  type: 'time',
                                  time: {
                                    unit: 'day',
                                    displayFormats: {
                                      millisecond: dateFormat,
                                      second: dateFormat,
                                      minute: dateFormat,
                                      hour: dateFormat,
                                      day: dateFormat,
                                    },
                                    tooltipFormat: 'L',
                                  },
                                  bounds: 'ticks',
                                  min: moment(dateRange.start)
                                    .startOf('day')
                                    .toISOString(),
                                  max: moment(dateRange.end)
                                    .endOf('day')
                                    .toISOString(),
                                  ticks: {
                                    autoSkip: true,
                                    display: true,
                                    color: theme.palette.text.secondary,
                                    includeBounds: true,
                                  },
                                  grid: {
                                    color: 'rgba(127 127 127/0.2)',
                                  },
                                },
                              },
                            }}
                            data={ticketCountChartData}
                          />
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                )}
              {/*}
              {!!soldTicketCountChartData.datasets &&
                !soldTicketCountChartData.datasets[0].data.length && (
                  <Typography>No tickets sold</Typography>
                )}
                {*/}
              {!!soldTicketCountChartData.datasets &&
                !!soldTicketCountChartData.datasets[0].data.length && (
                  <Card
                    sx={{
                      gridColumn: { xs: 'span 1', md: 'span 2' },
                    }}
                  >
                    <CardContent>
                      <Box
                        sx={{ flexBasis: { xs: '100%', sm: 0 }, flexGrow: 1 }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                          }}
                        >
                          <Typography
                            variant="h3"
                            sx={{ fontSize: '1rem', mb: '16px' }}
                          >
                            Tickets sold on the given date
                          </Typography>
                          <Typography
                            variant="h3"
                            sx={{ fontSize: '1rem', mb: '16px' }}
                          >
                            Total: {formatNumber(data.ticketCount)}
                          </Typography>
                        </Box>
                        <Box sx={{ height: isWide ? '270px' : '160px' }}>
                          <Bar
                            options={{
                              responsive: true,
                              maintainAspectRatio: false,
                              plugins: {
                                legend: {
                                  display: false,
                                  position: 'top' as const,
                                },
                                title: {
                                  display: false,
                                  text: 'Tickets sold on the given date',
                                  color: theme.palette.text.secondary,
                                  font: { weight: '500', size: 15 },
                                },
                              },

                              scales: {
                                y: {
                                  ticks: {
                                    autoSkip: true,
                                    color: theme.palette.text.secondary,
                                  },
                                  grid: {
                                    color: 'rgba(127 127 127/0.2)',
                                  },
                                },
                                x: {
                                  type: 'time',
                                  time: {
                                    unit: 'day',
                                    displayFormats: {
                                      millisecond: dateFormat,
                                      second: dateFormat,
                                      minute: dateFormat,
                                      hour: dateFormat,
                                      day: dateFormat,
                                    },
                                    tooltipFormat: 'L',
                                  },
                                  bounds: 'ticks',
                                  min: moment(dateRange.start)
                                    .startOf('day')
                                    .toISOString(),
                                  max: moment(dateRange.end)
                                    .endOf('day')
                                    .toISOString(),
                                  ticks: {
                                    autoSkip: true,
                                    display: true,
                                    color: theme.palette.text.secondary,
                                    includeBounds: true,
                                  },
                                  grid: {
                                    color: 'rgba(127 127 127/0.2)',
                                  },
                                },
                              },
                            }}
                            data={soldTicketCountChartData}
                          />
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                )}

              {!!data.ticketCountPerEventTypeSorted &&
                data.ticketCountPerEventTypeSorted.length >= 5 && (
                  <TableContainer component={Paper} sx={{ width: '100%' }}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>
                            <Typography variant="h3" sx={{ fontSize: '1rem' }}>
                              Top 5 worst performing
                            </Typography>
                          </TableCell>
                          <TableCell align="right">
                            <Typography variant="h3" sx={{ fontSize: '1rem' }}>
                              Tickets sold
                            </Typography>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {data.ticketCountPerEventTypeSorted
                          .slice(
                            data.ticketCountPerEventTypeSorted.length < 10
                              ? -data.ticketCountPerEventTypeSorted.length - 5
                              : -5,
                          )
                          // eslint-disable-next-line sonarjs/no-identical-functions
                          .map((row) => (
                            <TableRow
                              key={row.id}
                              sx={{
                                '&:last-child td, &:last-child th': {
                                  border: 0,
                                },
                              }}
                            >
                              <TableCell component="th" scope="row">
                                {row.name}
                              </TableCell>
                              <TableCell align="right">
                                {formatNumber(row._count)}
                              </TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              {/*}
              {!!orderCountChartData.datasets &&
                !orderCountChartData.datasets[0].data.length && (
                  <Typography>No orders</Typography>
                )}
                {*/}

              {/*}
              {!!eventCountChartData.datasets &&
                !eventCountChartData.datasets[0].data.length && (
                  <Typography>No events</Typography>
                )}
                {*/}
              {!!eventCountChartData.datasets &&
                !!eventCountChartData.datasets[0].data.length && (
                  <Card
                    sx={{
                      gridColumn: { xs: 'span 1', md: 'span 2' },
                    }}
                  >
                    <CardContent>
                      <Box
                        sx={{ flexBasis: { xs: '100%', sm: 0 }, flexGrow: 1 }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                          }}
                        >
                          <Typography
                            variant="h3"
                            sx={{ fontSize: '1rem', mb: '16px' }}
                          >
                            Events
                          </Typography>
                          <Typography
                            variant="h3"
                            sx={{ fontSize: '1rem', mb: '16px' }}
                          >
                            Total: {formatNumber(data.eventCount)}
                          </Typography>
                        </Box>
                        <Box sx={{ height: isWide ? '270px' : '160px' }}>
                          <Bar
                            options={{
                              responsive: true,
                              maintainAspectRatio: false,
                              plugins: {
                                legend: {
                                  display: false,
                                  position: 'top' as const,
                                },
                                title: {
                                  display: false,
                                  text: 'Events',
                                  color: theme.palette.text.secondary,
                                  font: { weight: '500', size: 15 },
                                },
                              },
                              scales: {
                                y: {
                                  ticks: {
                                    autoSkip: true,
                                    color: theme.palette.text.secondary,
                                  },
                                  grid: {
                                    color: 'rgba(127 127 127/0.2)',
                                  },
                                },
                                x: {
                                  type: 'time',
                                  time: {
                                    unit: 'day',
                                    displayFormats: {
                                      millisecond: dateFormat,
                                      second: dateFormat,
                                      minute: dateFormat,
                                      hour: dateFormat,
                                      day: dateFormat,
                                      month: dateFormat,
                                    },
                                    tooltipFormat: 'L',
                                  },
                                  bounds: 'ticks',
                                  min: moment(dateRange.start)
                                    .startOf('day')
                                    .toISOString(),
                                  max: moment(dateRange.end)
                                    .endOf('day')
                                    .toISOString(),
                                  ticks: {
                                    autoSkip: true,
                                    display: true,
                                    color: theme.palette.text.secondary,
                                    includeBounds: true,
                                  },
                                  grid: {
                                    color: 'rgba(127 127 127/0.2)',
                                  },
                                },
                              },
                            }}
                            data={eventCountChartData}
                          />
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                )}
              {!!orderCountChartData.datasets &&
                !!orderCountChartData.datasets[0].data.length && (
                  <Card
                    sx={{
                      gridColumn: { xs: 'span 1', md: 'span 2' },
                    }}
                  >
                    <CardContent>
                      <Box
                        sx={{ flexBasis: { xs: '100%', sm: 0 }, flexGrow: 1 }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                          }}
                        >
                          <Typography
                            variant="h3"
                            sx={{ fontSize: '1rem', mb: '16px' }}
                          >
                            Orders
                          </Typography>
                          <Typography
                            variant="h3"
                            sx={{ fontSize: '1rem', mb: '16px' }}
                          >
                            Total: {formatNumber(data.orderCountTotal)}
                          </Typography>
                        </Box>
                        <Box sx={{ height: isWide ? '270px' : '160px' }}>
                          <Bar
                            options={{
                              responsive: true,
                              maintainAspectRatio: false,
                              plugins: {
                                legend: {
                                  display: false,
                                  position: 'top' as const,
                                },
                                title: {
                                  display: false,
                                  text: 'Orders',
                                  color: theme.palette.text.secondary,
                                  font: { weight: '500', size: 15 },
                                },
                              },

                              scales: {
                                y: {
                                  ticks: {
                                    autoSkip: true,
                                    color: theme.palette.text.secondary,
                                  },
                                  grid: {
                                    color: 'rgba(127 127 127/0.2)',
                                  },
                                },
                                x: {
                                  type: 'time',
                                  time: {
                                    unit: 'day',
                                    displayFormats: {
                                      millisecond: dateFormat,
                                      second: dateFormat,
                                      minute: dateFormat,
                                      hour: dateFormat,
                                      day: dateFormat,
                                    },
                                    tooltipFormat: 'L',
                                  },
                                  bounds: 'ticks',
                                  min: moment(dateRange.start)
                                    .startOf('day')
                                    .toISOString(),
                                  max: moment(dateRange.end)
                                    .endOf('day')
                                    .toISOString(),

                                  ticks: {
                                    autoSkip: true,
                                    display: true,

                                    color: theme.palette.text.secondary,
                                    includeBounds: true,
                                  },
                                  grid: {
                                    color: 'rgba(127 127 127/0.2)',
                                  },
                                },
                              },
                            }}
                            data={orderCountChartData}
                          />
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                )}
            </Box>
          </>
        )}
      </Box>
    </>
  );
};
